
import { defineComponent, computed } from 'vue';
import { Form } from 'ant-design-vue';
import myModal from './Modal.vue';

export default defineComponent({
  components: {
    myModal,
    aForm: Form,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    okText: {
      type: String,
      default: '确认',
    },
    cancelText: {
      type: String,
      default: '取消',
    },
    form: {
      type: Object,
      require: true,
    },
  },
  emits: ['onCancel', 'onOk'],
  setup(props, { emit }) {
    const basicVisible = computed(() => props.visible);
    const basicLoading = computed(() => props.loading);

    const onCancel = () => {
      emit('onCancel');
    };

    const onOk = async () => {
      emit('onOk');
    };

    return {
      basicVisible,
      basicLoading,
      onCancel,
      onOk,
    };
  },
});
